// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-help-__slug-indexstyleGrid-container-ultbp{margin:0 auto;max-width:1536px;padding:0 24px;width:100%}.pages-help-__slug-indexstyleGrid-grid-befyd{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.pages-help-__slug-indexstyleGrid-col6-rjbis{grid-column:span 6}.pages-help-__slug-indexstyleGrid-col3-mqkkv{grid-column:span 3}.pages-help-__slug-indexstyleGrid-col4-caifr{grid-column:span 4}.pages-help-__slug-indexstyleGrid-col9-bigxn{grid-column:span 9}.pages-help-__slug-indexstyleGrid-col12-bswgc{grid-column:span 12}.pages-help-__slug-indexstyleGrid-alignItemsStart-hieie{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "pages-help-__slug-indexstyleGrid-container-ultbp",
	"grid": "pages-help-__slug-indexstyleGrid-grid-befyd",
	"col6": "pages-help-__slug-indexstyleGrid-col6-rjbis",
	"col3": "pages-help-__slug-indexstyleGrid-col3-mqkkv",
	"col4": "pages-help-__slug-indexstyleGrid-col4-caifr",
	"col9": "pages-help-__slug-indexstyleGrid-col9-bigxn",
	"col12": "pages-help-__slug-indexstyleGrid-col12-bswgc",
	"alignItemsStart": "pages-help-__slug-indexstyleGrid-alignItemsStart-hieie"
};
module.exports = ___CSS_LOADER_EXPORT___;
